// ==========================================================================
// LMX SWIPER PAGINATION 
// ==========================================================================

(function () {
  var MOBILE_MQ = '(max-width: 767.98px)';
  var RETRY_MS = 120;
  var RETRY_MAX = 50;

  function isMobile() {
    return typeof window.matchMedia !== 'undefined' && window.matchMedia(MOBILE_MQ).matches;
  }

  function getSwiperInstance(host) {
    if (!host) return null;
    if (host.swiper) return host.swiper;
    if (host.globalSlide) return host.globalSlide;
    var st = host.closest && host.closest('slide-with-thumbs');
    if (st && st.globalSlide) return st.globalSlide;
    return null;
  }

  function getLmxSwiperHosts() {
    var seen = new Set();
    var out = [];
    document.querySelectorAll('.lmx-product-item').forEach(function (card) {
      var host =
        card.closest('slide-section') ||
        card.closest('slide-section-product-set') ||
        card.closest('slide-section-lookbook') ||
        card.closest('carousel-mobile') ||
        card.closest('grid-custom') ||
        card.closest('.swiper');
      if (!host || !host.classList.contains('swiper')) return;
      if (seen.has(host)) return;
      seen.add(host);
      out.push(host);
    });
    return out;
  }

  function getMediaGallerySwiperHosts() {
    var seen = new Set();
    var out = [];
    document.querySelectorAll('slide-with-thumbs .swiper-wrapper-preview.swiper').forEach(function (preview) {
      if (seen.has(preview)) return;
      seen.add(preview);
      out.push(preview);
    });
    return out;
  }

  function getAllSwiperHosts() {
    var seen = new Set();
    var out = [];
    getLmxSwiperHosts().concat(getMediaGallerySwiperHosts()).forEach(function (h) {
      if (seen.has(h)) return;
      seen.add(h);
      out.push(h);
    });
    return out;
  }

  function defaultFractionRender(swiper, current, total) {
    return current + '/' + total;
  }

  function applyPaginationMode(host, mobile) {
    var sw = getSwiperInstance(host);
    if (!sw || !sw.params || !sw.pagination) return false;
    var pag = sw.params.pagination;
    if (!pag || typeof pag !== 'object') return false;

    if (mobile) {
      if (pag.type === 'bullets' && pag._lmxPatched) return true;
      if (pag.type !== 'custom') return true;
      if (pag.renderCustom && !pag._lmxSavedRender) {
        pag._lmxSavedRender = pag.renderCustom;
      }
      pag._lmxPatched = true;
      pag.type = 'bullets';
      delete pag.renderCustom;
      try {
        if (sw.pagination.destroy) sw.pagination.destroy();
        sw.pagination.init();
        sw.pagination.render();
        sw.pagination.update();
      } catch (e) {
        return false;
      }
    } else {
      if (!pag._lmxPatched) return true;
      pag.type = 'custom';
      pag.renderCustom = pag._lmxSavedRender || defaultFractionRender;
      delete pag._lmxSavedRender;
      delete pag._lmxPatched;
      try {
        if (sw.pagination.destroy) sw.pagination.destroy();
        sw.pagination.init();
        sw.pagination.render();
        sw.pagination.update();
      } catch (e) {
        return false;
      }
    }
    return true;
  }

  function runPatch() {
    var hosts = getAllSwiperHosts();
    if (hosts.length === 0) return true;
    var mobile = isMobile();
    var ok = true;
    hosts.forEach(function (host) {
      if (!applyPaginationMode(host, mobile)) ok = false;
    });
    return ok;
  }

  function scheduleRetries() {
    var n = 0;
    var tick = function () {
      runPatch();
      n++;
      if (n < RETRY_MAX) setTimeout(tick, RETRY_MS);
    };
    tick();
  }

  function onReady() {
    runPatch();
    scheduleRetries();
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      runPatch();
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function () {
    onReady();
  });

  window.addEventListener('resize', onResize);

  /* skeleton-loading: al “live” il tema può aggiornare il DOM — ripatch */
  if (typeof MutationObserver !== 'undefined') {
    var moTimer;
    var mo = new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        runPatch();
      }, 50);
    });
    function bindMediaMainObservers() {
      document.querySelectorAll('.media-main-swiper').forEach(function (el) {
        if (el._lmxSkeletonObs) return;
        el._lmxSkeletonObs = true;
        mo.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
    }
    document.addEventListener('DOMContentLoaded', bindMediaMainObservers);
    document.addEventListener('shopify:section:load', bindMediaMainObservers);
  }
})();

// ==========================================================================
// PDP GALLERY — almeno 8 slide (clone DOM + id unici) per riempire viewport / loop
// ==========================================================================

(function () {
  var DEFAULT_MIN = 8;
  var RETRY_MS = 100;
  var RETRY_MAX = 45;

  function uniquifySubtreeIds(root, suffix) {
    if (!root || !suffix) return;
    root.querySelectorAll('[id]').forEach(function (el) {
      var id = el.id;
      if (id) el.id = String(id) + suffix;
    });
  }

  function countNonDuplicateSlides(sw) {
    return Array.prototype.filter.call(sw.slides, function (s) {
      return !s.classList.contains('swiper-slide-duplicate');
    }).length;
  }

  function enforcePdpGalleryZeroGap(host, sw) {
    if (!host || !sw || sw.destroyed || !host.closest('.lmx-carousel-layout')) return;
    try {
      sw.params.spaceBetween = 0;
      if (sw.originalParams && typeof sw.originalParams === 'object') {
        sw.originalParams.spaceBetween = 0;
      }
      var bps = sw.params.breakpoints;
      if (bps && typeof bps === 'object') {
        Object.keys(bps).forEach(function (k) {
          if (bps[k] && typeof bps[k] === 'object') {
            bps[k].spaceBetween = 0;
          }
        });
      }
      sw.update();
    } catch (e0) {}
    try {
      Array.prototype.forEach.call(sw.slides, function (slide) {
        slide.style.setProperty('margin-right', '0', 'important');
        slide.style.setProperty('margin-left', '0', 'important');
        slide.style.setProperty('margin-inline', '0', 'important');
      });
    } catch (e1) {}
  }

  function wrapPdpGalleryPagination(host, sw) {
    if (!host || !sw || !sw.params || !sw.params.pagination || host._lmxPdpPagWrapped) return;
    var unique = parseInt(host.dataset.lmxUniqueSlides, 10);
    if (!(unique >= 1)) {
      host._lmxPdpPagWrapped = true;
      return;
    }
    var real = countNonDuplicateSlides(sw);
    if (real <= unique) {
      host._lmxPdpPagWrapped = true;
      return;
    }
    var pag = sw.params.pagination;
    var prev = typeof pag.renderCustom === 'function' ? pag.renderCustom : null;
    pag.renderCustom = function (swiper, current, total) {
      if (typeof swiper.realIndex === 'number' && total > unique) {
        return (swiper.realIndex % unique) + 1 + '/' + unique;
      }
      return prev ? prev(swiper, current, total) : current + '/' + total;
    };
    try {
      if (sw.pagination && sw.pagination.render) {
        sw.pagination.render();
        sw.pagination.update();
      }
    } catch (e3) {}
    host._lmxPdpPagWrapped = true;
  }

  function padLmxPdpCarousel(host) {
    if (!host || host._lmxPadSlidesDone) return false;
    if (!host.closest || !host.closest('.lmx-carousel-layout')) return false;
    var sw = host.globalSlide;
    if (!sw || sw.destroyed || typeof sw.appendSlide !== 'function') return false;

    var minTarget = DEFAULT_MIN;
    if (host.dataset && host.dataset.lmxMinCarouselSlides) {
      var parsed = parseInt(host.dataset.lmxMinCarouselSlides, 10);
      if (parsed >= 2 && isFinite(parsed)) minTarget = parsed;
    }

    var nonDup = Array.prototype.filter.call(sw.slides, function (s) {
      return !s.classList.contains('swiper-slide-duplicate');
    });
    if (nonDup.length < 1) return false;
    if (nonDup.length >= minTarget) {
      host._lmxPadSlidesDone = true;
      return true;
    }

    host._lmxDupSeq = host._lmxDupSeq || 0;
    var hadLoop = !!(sw.params && sw.params.loop);

    try {
      if (hadLoop && typeof sw.loopDestroy === 'function') {
        sw.loopDestroy();
        sw.params.loop = false;
      }
    } catch (e0) {}

    var originals = Array.prototype.filter.call(sw.slides, function (s) {
      return !s.classList.contains('swiper-slide-duplicate');
    });
    var origCount = originals.length;
    var safety = 0;
    while (countNonDuplicateSlides(sw) < minTarget && safety < 40) {
      for (var i = 0; i < origCount; i++) {
        if (countNonDuplicateSlides(sw) >= minTarget) break;
        var c = originals[i].cloneNode(true);
        host._lmxDupSeq += 1;
        uniquifySubtreeIds(c, '-lmx' + host._lmxDupSeq);
        sw.appendSlide(c);
      }
      safety += 1;
    }

    try {
      sw.update();
      if (hadLoop) {
        sw.params.loop = true;
        if (typeof sw.loopCreate === 'function') sw.loopCreate();
        sw.update();
      }
    } catch (e1) {}

    try {
      if (sw.pagination && sw.pagination.render) {
        sw.pagination.render();
        sw.pagination.update();
      }
    } catch (e2) {}

    host._lmxPadSlidesDone = true;
    window.dispatchEvent(new Event('resize'));
    return true;
  }

  function tryPadAll() {
    document.querySelectorAll('.lmx-carousel-layout slide-with-thumbs').forEach(function (host) {
      padLmxPdpCarousel(host);
      var sw = host.globalSlide;
      if (sw) {
        enforcePdpGalleryZeroGap(host, sw);
        wrapPdpGalleryPagination(host, sw);
      }
    });
  }

  function schedulePad() {
    var n = 0;
    var tick = function () {
      tryPadAll();
      n += 1;
      if (n < RETRY_MAX) setTimeout(tick, RETRY_MS);
    };
    tick();
  }

  function onReady() {
    schedulePad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.lmx-carousel-layout slide-with-thumbs').forEach(function (host) {
      host._lmxPadSlidesDone = false;
      host._lmxPdpPagWrapped = false;
    });
    schedulePad();
  });

  var zeroGapResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(zeroGapResizeTimer);
    zeroGapResizeTimer = setTimeout(function () {
      document.querySelectorAll('.lmx-carousel-layout slide-with-thumbs').forEach(function (host) {
        if (host.globalSlide) enforcePdpGalleryZeroGap(host, host.globalSlide);
      });
    }, 200);
  });
})();

// ==========================================================================
// XREF2 SWATCHES — lmx-color-swatches.liquid 
// ==========================================================================

(function () {
  function initXref2Swatches(root) {
    root.querySelectorAll('.xref2-swatch').forEach(function (swatch) {
      const card = swatch.closest('.product-item');
      if (!card) return;

      const cardImg = card.querySelector('.product__media .product-image.first-image');
      if (!cardImg) return;

      const hoverImage = swatch.dataset.xref2Image;
      const hoverHref  = swatch.dataset.xref2Href;
      if (!hoverImage) return;

      let fadeTimer = null;

      cardImg.style.transition = 'opacity 0.2s ease';

      swatch.addEventListener('mouseenter', function () {
        card.querySelectorAll('.xref2-swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');

        clearTimeout(fadeTimer);
        cardImg.style.opacity = '0';
        fadeTimer = setTimeout(function () {
          cardImg.removeAttribute('srcset');
          cardImg.setAttribute('src', hoverImage);
          cardImg.style.opacity = '1';
        }, 200);
      });

      swatch.addEventListener('click', function () {
        if (hoverHref) window.location.href = hoverHref;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initXref2Swatches(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initXref2Swatches(e.target);
  });
})();

// ==========================================================================
// LM NEWSLETTER POPUP — lm-newsletter.liquid
// ==========================================================================

(function () {
    const POPUP_CLASS = 'lm-newsletter-popup';
    const OPEN_BODY_CLASS = 'lm-newsletter-popup--open';
  
    function openPopup(popup) {
      if (!popup) return;
      popup.removeAttribute('hidden');
      document.body.classList.add(OPEN_BODY_CLASS);
      popup.querySelector('.lm-newsletter-popup__close')?.focus();
    }
  
    function closePopup(popup) {
      if (!popup) return;
      popup.setAttribute('hidden', '');
      document.body.classList.remove(OPEN_BODY_CLASS);
    }
  
    document.addEventListener('click', function (e) {
      const openBtn = e.target.closest('.lm-newsletter__open-btn');
      if (openBtn) {
        openPopup(document.getElementById(openBtn.dataset.popup));
        return;
      }

      const klaviyoBtn = e.target.closest('.lm-newsletter-popup__klaviyo-btn');
      if (klaviyoBtn) {
        const popup = klaviyoBtn.closest('.' + POPUP_CLASS);
        const klaviyoId = popup?.dataset.klaviyoId;
        if (klaviyoId) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', klaviyoId]);
        }
        closePopup(popup);
        return;
      }

      if (e.target.closest('[data-close-popup]')) {
        const popup = e.target.closest('.' + POPUP_CLASS);
        closePopup(popup);
      }
    });
  

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelector('.' + POPUP_CLASS + ':not([hidden])')
        ? closePopup(document.querySelector('.' + POPUP_CLASS + ':not([hidden])'))
        : null;
    });
  
  })();


// ==========================================================================
// LMX VARIANT PICKER — 
// ==========================================================================

(function () {
  function findVariantRadios(root) {
    return root.querySelector('variant-radios-detail, variant-group-detail');
  }

  function getVariantForProductRoot(root) {
    var vr = findVariantRadios(root);
    if (!vr) return null;
    var sectionId = vr.dataset.section;
    if (!sectionId) return null;
    var form = document.getElementById('product-form-' + sectionId);
    if (!form) return null;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return null;
    var jsonScript = vr.querySelector('script[type="application/json"]');
    if (!jsonScript) return null;
    var variants = JSON.parse(jsonScript.textContent);
    var vid = parseInt(idInput.value, 10);
    return variants.find(function (v) {
      return v.id === vid;
    });
  }

  function syncLmxDropdownLabels(root) {
    var pickers = root.querySelectorAll('.lmx-variant-picker');
    if (!pickers.length) return;
    var hasPosFieldset = false;
    pickers.forEach(function (p) {
      if (p.querySelector('fieldset[data-option-position]')) hasPosFieldset = true;
    });
    if (!hasPosFieldset) return;
    var variant = getVariantForProductRoot(root);
    if (!variant) return;
    pickers.forEach(function (picker) {
      var noPreselect = picker.dataset.noPreselect === 'true';
      picker.querySelectorAll('fieldset[data-option-position]').forEach(function (fieldset) {
        var pos = parseInt(fieldset.dataset.optionPosition, 10);
        if (!pos || pos < 1 || pos > 3) return;
        // Con no-preselect attivo, aggiorna il label solo se per quella
        // posizione di opzione esiste almeno un radio selezionato in
        // qualsiasi picker del prodotto (non solo in questo).
        if (noPreselect) {
          var anyChecked = root.querySelector(
            '.lmx-variant-picker fieldset[data-option-position="' + pos + '"] input:checked'
          );
          if (!anyChecked) return;
        }
        var val = variant['option' + pos];
        if (val == null) return;
        fieldset.querySelectorAll('.option_value').forEach(function (span) {
          span.textContent = val;
        });
      });
    });
  }

  function scheduleSync(root) {
    if (!root) return;
    setTimeout(function () {
      syncLmxDropdownLabels(root);
    }, 0);
  }

  // Aggiorna i label .option_value di TUTTI i picker per la posizione indicata.
  function updateOptionLabels(root, pos, val) {
    root.querySelectorAll(
      '.lmx-variant-picker fieldset[data-option-position="' + pos + '"] .option_value'
    ).forEach(function (span) {
      span.textContent = val;
    });
  }

  // Abilita i pulsanti acquisto del prodotto (lm-buy-buttons.liquid).
  // Chiamato ogni volta che l'utente seleziona un'opzione nel picker —
  // necessario perché VariantRadiosDetail non trova la variante corretta
  // con prodotti XREF2 (colore gestito a livello prodotto, non come option).
  function enableBuyButtons(root) {
    root.querySelectorAll('.lm-buy-container').forEach(function (c) {
      c.classList.add('lm-variant-ready');
    });

    // Forza aggiornamento ?variant= in URL tramite il form hidden input.
    // Usa un setTimeout(0) per lasciare tempo a onVariantChange (theme.js) di
    // aggiornare prima input[name="id"] — se riesce. Se ha già aggiornato
    // correttamente l'URL da solo, il replaceState qui è un no-op (stesso valore).
    setTimeout(function () {
      var form = root.querySelector('[id^="product-form-"]');
      if (!form) return;
      var inp = form.querySelector('input[name="id"]');
      if (!inp || !inp.value) return;
      try {
        var newUrl = new URL(window.location.href);
        if (newUrl.searchParams.get('variant') !== String(inp.value)) {
          newUrl.searchParams.set('variant', inp.value);
          history.replaceState({}, '', newUrl.toString());
        }
      } catch (e) {}
    }, 0);
  }

  // CLICK — cattura la selezione sui label dei dropdown (data-value) e
  // sui label delle swatches (valore come testo nel figlio span).
  // Più affidabile del solo 'change' perché non dipende da ID o radio state.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('.product__item-js');
    if (!root) return;

    // Label dentro un swatch-dropdown (dropdown mode): ha data-value
    var dropLabel = t.closest('.lmx-variant-picker swatch-dropdown .product__color-swatches--js[data-value]');
    if (dropLabel) {
      var fieldset = dropLabel.closest('fieldset[data-option-position]');
      if (fieldset) {
        updateOptionLabels(root, fieldset.dataset.optionPosition, dropLabel.dataset.value);
        enableBuyButtons(root);
      }
      // Chiudi il dropdown
      var selectCustom = dropLabel.closest('.select-custom');
      if (selectCustom) selectCustom.classList.remove('active');
      return;
    }

    // Label swatches (fuori dropdown): il valore è nel testo del label
    var swatchLabel = t.closest('.lmx-variant-picker fieldset[data-option-position] .product__item-option');
    if (swatchLabel) {
      var swatchFieldset = swatchLabel.closest('fieldset[data-option-position]');
      var swatchSpan = swatchLabel.querySelector('span');
      if (swatchFieldset && swatchSpan) {
        updateOptionLabels(root, swatchFieldset.dataset.optionPosition, swatchSpan.textContent.trim());
        enableBuyButtons(root);
      }
    }
  });

  // CHANGE sui radio — fallback e copertura per variazioni programmatiche
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('.product__item-js');
    if (!root) return;

    if (t.type === 'radio' && t.closest('.lmx-variant-picker')) {
      var changedFieldset = t.closest('fieldset[data-option-position]');
      if (changedFieldset) {
        updateOptionLabels(root, changedFieldset.dataset.optionPosition, t.value);
      }
      enableBuyButtons(root);
      return;
    }
    if (t.name === 'id' && t.closest('[id^="product-form-"]')) {
      scheduleSync(root);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__item-js').forEach(scheduleSync);
  });

  document.addEventListener('shopify:section:load', function (e) {
    scheduleSync(e.target);
  });
})();

// ==========================================================================
// LMX VARIANT PICKER — active-variant + pulsante acquisto via URL
// ==========================================================================
// Due responsabilità separate:
//
// 1. ACTIVE-VARIANT (visuale)
//    Listener click su label.product__item-option → aggiorna la classe active-variant
//
// 2. STATO PULSANTE (funzionale)
//    Intercetta history.replaceState (usato da Shopify quando la variante cambia):
//    - Se URL contiene ?variant= → abilita i pulsanti
//    - Gestisce sia lm-buy-buttons.liquid (CSS class) sia _product-buy-buttons.liquid (btn.disabled)
//    Gestisce anche popstate (navigazione browser avanti/indietro)

(function () {

  // ---- Utilità URL ----
  function urlHasVariant(url) {
    try {
      return new URL(url, window.location.origin).searchParams.has('variant');
    } catch (e) {
      return /[?&]variant=/.test(url);
    }
  }

  // ---- Sync pulsanti in base a URL ----
  function syncBuyState(url) {
    if (!urlHasVariant(url)) return;

    // lm-buy-buttons.liquid: aggiunge classe CSS → il CSS rivela i pulsanti reali
    document.querySelectorAll('.lm-buy-container').forEach(function (c) {
      c.classList.add('lm-variant-ready');
    });

    // _product-buy-buttons.liquid: re-abilita pulsante disabilitato dallo script inline
    document.querySelectorAll('[name="add"][data-lm-np-disabled]').forEach(function (btn) {
      btn.disabled = false;
      delete btn.dataset.lmNpDisabled;
      var lbl = btn.querySelector('.btn-label');
      if (lbl && btn.dataset.lmOrigText) {
        lbl.textContent = btn.dataset.lmOrigText;
        delete btn.dataset.lmOrigText;
      }
    });
  }

  // ---- Intercetta history.replaceState (Shopify lo usa per aggiornare ?variant=) ----
  (function () {
    var orig = history.replaceState;
    history.replaceState = function (state, title, url) {
      orig.apply(this, arguments);
      if (url) syncBuyState(String(url));
    };
  })();

  // ---- Navigazione browser avanti/indietro ----
  window.addEventListener('popstate', function () {
    syncBuyState(window.location.href);
  });

  // ---- Active-variant: gestione visuale della label selezionata ----
  function isNoPreselectFieldset(fieldset) {
    return !!fieldset.closest('.lmx-variant-picker[data-no-preselect="true"]')
      && !fieldset.classList.contains('product-form__input_color');
  }

  function initActiveVariant(root) {
    root.querySelectorAll('.lmx-variant-picker fieldset').forEach(function (fieldset) {
      if (isNoPreselectFieldset(fieldset)) return;
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var label = fieldset.querySelector('label[for="' + checked.id + '"]');
      if (label && label.classList.contains('product__item-option')) {
        label.classList.add('active-variant');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var label = e.target.closest('label.product__item-option');
    if (!label) return;
    if (!label.closest('.lmx-variant-picker')) return;
    var fieldset = label.closest('fieldset');
    if (!fieldset) return;

    fieldset.querySelectorAll('label.product__item-option').forEach(function (l) {
      l.classList.remove('active-variant');
    });
    label.classList.add('active-variant');
  });

  document.addEventListener('DOMContentLoaded', function () { initActiveVariant(document); });
  document.addEventListener('shopify:section:load', function (e) { initActiveVariant(e.target); });

})();

// ==========================================================================
// LMX STICKY ADD CART —
// ==========================================================================


(function () {
  var STICKY_MIN_SCROLL_PX = 1000;

  function injectStickyScrollGateStyle() {
    if (document.getElementById('lmx-sticky-scroll-gate')) return;
    var s = document.createElement('style');
    s.id = 'lmx-sticky-scroll-gate';
    s.textContent =
      'sticky-add-cart.lmx-scroll-below-threshold{display:none!important;}';
    document.head.appendChild(s);
  }

  var stickiesScrollGate = [];
  var scrollGateRaf = null;

  function updateStickyScrollGates() {
    var y = window.scrollY || document.documentElement.scrollTop;
    stickiesScrollGate = stickiesScrollGate.filter(function (st) {
      return st && st.isConnected;
    });
    stickiesScrollGate.forEach(function (st) {
      st.classList.toggle('lmx-scroll-below-threshold', y < STICKY_MIN_SCROLL_PX);
    });
  }

  function onStickyScrollGateScroll() {
    if (scrollGateRaf) return;
    scrollGateRaf = requestAnimationFrame(function () {
      scrollGateRaf = null;
      updateStickyScrollGates();
    });
  }

  function registerStickyScrollGate(sticky) {
    injectStickyScrollGateStyle();
    if (stickiesScrollGate.indexOf(sticky) === -1) {
      stickiesScrollGate.push(sticky);
    }
    if (stickiesScrollGate.length === 1) {
      window.addEventListener('scroll', onStickyScrollGateScroll, { passive: true });
    }
    updateStickyScrollGates();
  }

  function unregisterStickyScrollGate(sticky) {
    var i = stickiesScrollGate.indexOf(sticky);
    if (i !== -1) {
      stickiesScrollGate.splice(i, 1);
      sticky.classList.remove('lmx-scroll-below-threshold');
    }
    if (stickiesScrollGate.length === 0) {
      window.removeEventListener('scroll', onStickyScrollGateScroll);
    }
  }

  function initStickyPickerObserver(root) {
    root.querySelectorAll('.lmx-variant-picker').forEach(function (picker) {
      if (picker._lmxStickyObs) return;

      var product = picker.closest('.sec__featured-product');
      if (!product) return;
      var sticky = product.querySelector('sticky-add-cart');
      if (!sticky) return;

      registerStickyScrollGate(sticky);

      var debounceTimer;
      var io = new IntersectionObserver(function (entries) {
        var isVisible = entries[entries.length - 1].isIntersecting;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          sticky.classList.toggle('lmx-picker-visible', isVisible);
        }, 80);
      }, {
        threshold: 0,
        rootMargin: '0px 0px -80px 0px'
      });
      io.observe(picker);

      picker._lmxStickyObs = { io: io, sticky: sticky };
    });
  }

  function teardownStickyPickerObserver(root) {
    root.querySelectorAll('.lmx-variant-picker').forEach(function (picker) {
      if (!picker._lmxStickyObs) return;
      picker._lmxStickyObs.io.disconnect();
      if (picker._lmxStickyObs.sticky) {
        unregisterStickyScrollGate(picker._lmxStickyObs.sticky);
      }
      picker._lmxStickyObs = null;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyPickerObserver(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initStickyPickerObserver(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    teardownStickyPickerObserver(e.target);
  });
})();

// ==========================================================================
// PDP GALLERY — loop Swiper: slideToLoop per indice reale (variant / sync)
// ==========================================================================

(function () {
  function patchSlideWithThumbsGotoForLoop() {
    var CE = typeof customElements !== 'undefined' && customElements.get('slide-with-thumbs');
    if (!CE || !CE.prototype || CE.prototype._lmxSlideToLoopPatched) return;
    var origGoto = CE.prototype.functionGoto;
    CE.prototype._lmxSlideToLoopPatched = true;
    CE.prototype.functionGoto = function (position) {
      var sw = this.globalSlide;
      if (sw && sw.params && sw.params.loop && typeof sw.slideToLoop === 'function') {
        sw.slideToLoop(Number(position), 500);
        return;
      }
      return origGoto.call(this, position);
    };
  }

  function onReady() {
    patchSlideWithThumbsGotoForLoop();
    setTimeout(patchSlideWithThumbsGotoForLoop, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

// ==========================================================================
// PDP GALLERY — mobile PhotoSwipe: href mancante (inner/external zoom) + click Swiper
// ==========================================================================
(function () {
  var MOBILE_MQ = '(max-width: 767.98px)';
  var RETRY_MS = 100;
  var RETRY_MAX = 50;

  function isMobile() {
    return typeof window.matchMedia !== 'undefined' && window.matchMedia(MOBILE_MQ).matches;
  }

  function pdpRoot() {
    return document.querySelector('.sec__featured-product[data-lmx-pdp]');
  }

  function largestUrlFromImg(img) {
    if (!img) return '';
    var ss = img.getAttribute('srcset');
    if (ss) {
      var best = '';
      var bestW = 0;
      ss.split(',').forEach(function (part) {
        var p = part.trim();
        if (!p) return;
        var wMatch = p.match(/\s+(\d+)w\s*$/);
        var w = wMatch ? parseInt(wMatch[1], 10) : 0;
        var url = p.replace(/\s+\d+w\s*$/, '').trim();
        if (w > bestW) {
          bestW = w;
          best = url;
        }
        if (w === 0 && !best) best = url;
      });
      if (best) return best;
    }
    return img.currentSrc || img.src || '';
  }

  function upsizeShopifyImageUrl(url) {
    if (!url) return '';
    var out = url;
    try {
      var u = new URL(url, window.location.origin);
      if (u.hostname.indexOf('cdn.shopify') !== -1 || u.searchParams.has('width') || u.pathname.indexOf('/cdn/') !== -1) {
        u.searchParams.set('width', '2560');
        out = u.toString();
      } else {
        if (url.indexOf('?') !== -1) {
          out = url + '&width=2560';
        } else {
          out = url + '?width=2560';
        }
      }
    } catch (e) {
      return url;
    }
    return out;
  }

  function fillPdpLightboxHrefs() {
    var root = pdpRoot();
    if (!root) return;
    var zoom = root.getAttribute('data-zoom');
    if (zoom === 'no_zoom') return;
    root.querySelectorAll('a.media-gallery__image').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h && h.length > 1 && h !== '#') return;
      var img = a.querySelector('img');
      if (!img) return;
      var base = largestUrlFromImg(img);
      if (!base) return;
      a.setAttribute('href', upsizeShopifyImageUrl(base));
    });
  }

  function patchLmxMainSwiperClickParams() {
    if (!isMobile()) return;
    document.querySelectorAll('.lmx-carousel-layout slide-with-thumbs').forEach(function (host) {
      var sw = host.globalSlide;
      if (!sw || sw.destroyed) return;
      if (sw._lmxPdpClicks) return;
      if (sw.params) {
        sw.params.preventClicks = false;
        if ('preventClicksPropagation' in sw.params) {
          sw.params.preventClicksPropagation = false;
        }
        sw._lmxPdpClicks = true;
        try {
          if (sw.update) sw.update();
        } catch (e0) {}
      }
    });
  }

  function tryPatchSlideWithThumbsPrototype() {
    var CE = typeof customElements !== 'undefined' && customElements.get('slide-with-thumbs');
    if (!CE || !CE.prototype || CE.prototype._lmxInitSlideClicksPatched) return;
    var orig = CE.prototype.initSlide;
    CE.prototype._lmxInitSlideClicksPatched = true;
    CE.prototype.initSlide = function () {
      orig.call(this);
      if (!this.closest || !this.closest('.lmx-carousel-layout')) return;
      var sw = this.globalSlide;
      if (!sw || !sw.params) return;
      if (isMobile()) {
        sw.params.preventClicks = false;
        if ('preventClicksPropagation' in sw.params) {
          sw.params.preventClicksPropagation = false;
        }
        sw._lmxPdpClicks = true;
      }
    };
  }

  function run() {
    tryPatchSlideWithThumbsPrototype();
    fillPdpLightboxHrefs();
    patchLmxMainSwiperClickParams();
  }

  var n = 0;
  function schedule() {
    n = 0;
    var tick = function () {
      run();
      n += 1;
      if (n < RETRY_MAX) setTimeout(tick, RETRY_MS);
    };
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  document.addEventListener('shopify:section:load', function () {
    n = 0;
    setTimeout(schedule, 0);
  });
  window.addEventListener('resize', function () {
    setTimeout(function () {
      run();
    }, 150);
  });
})();

// ==========================================================================
// MEASMERIZE — un solo #measmerize-button (app): specchio su desktop/mobile
// Il blocco app resta in una colonna; l’altra colonna riceve un clone senza id
// duplicati e i click/keydown vengono inoltrati al pulsante reale.
// Breakpoint 990px allineato a .lmx-col-right / .lmx-mobile-content in lmx-styles.css
// ==========================================================================

(function () {
  var RETRY_MS = 120;
  var RETRY_MAX = 60;

  function getPdpSection(el) {
    return el && el.closest && el.closest('[data-lmx-pdp="1"]');
  }

  function stripAllIds(root) {
    if (!root) return;
    root.removeAttribute('id');
    root.querySelectorAll('[id]').forEach(function (node) {
      node.removeAttribute('id');
    });
  }

  function forwardActivate(source, e) {
    var realBtn = source.querySelector('button[data-testid="cta-button"]') || source.querySelector('button[type="button"]') || source.querySelector('button');
    if (!realBtn) return;
    e.preventDefault();
    e.stopPropagation();
    realBtn.click();
  }

  function wireMirror(mirror, source) {
    mirror.addEventListener(
      'click',
      function (e) {
        if (!mirror.contains(e.target)) return;
        forwardActivate(source, e);
      },
      true
    );
    mirror.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (!mirror.contains(e.target)) return;
        forwardActivate(source, e);
      },
      true
    );
  }

  function removeProxies(section) {
    if (!section) return;
    section.querySelectorAll('[data-lmx-measmerize-proxy="1"]').forEach(function (el) {
      el.remove();
    });
    var src = document.getElementById('measmerize-button');
    if (src && section.contains(src)) {
      src.removeAttribute('data-lmx-measmerize-wired');
    }
  }

  function buildMirror(source, section, variant) {
    var sectionId = section.getAttribute('data-section') || 'pdp';
    var mirror = source.cloneNode(true);
    stripAllIds(mirror);
    mirror.setAttribute('data-lmx-measmerize-proxy', '1');
    mirror.classList.add('lmx-measmerize-proxy');
    if (variant === 'desktop') {
      mirror.classList.add('lmx-measmerize-proxy--desktop-only');
    } else {
      mirror.classList.add('lmx-measmerize-proxy--mobile-only');
    }
    mirror.id = 'lmx-measmerize-proxy-' + sectionId + '-' + variant;
    wireMirror(mirror, source);
    return mirror;
  }

  /** Contenitore: colonna. Cerca [data-lmx-measmerize-anchor="desktop|mobile"] dentro la colonna, altrimenti fine colonna. */
  function getMirrorHost(columnEl, variant) {
    if (!columnEl) return null;
    var which = variant === 'desktop' ? 'desktop' : 'mobile';
    var anchor = columnEl.querySelector('[data-lmx-measmerize-anchor="' + which + '"]');
    if (anchor && columnEl.contains(anchor)) return anchor;
    return columnEl;
  }

  function placeProxies() {
    var source = document.getElementById('measmerize-button');
    if (!source || source.getAttribute('data-lmx-measmerize-wired') === '1') return false;

    var section = getPdpSection(source);
    if (!section) return false;

    var btn = source.querySelector('button');
    if (!btn) return false;

    var mobileCol = section.querySelector('.lmx-mobile-content');
    var rightCol = section.querySelector('.lmx-col-right');
    var inMobile = source.closest('.lmx-mobile-content');
    var inRight = source.closest('.lmx-col-right');

    if (inMobile && rightCol) {
      if (!rightCol.querySelector('[data-lmx-measmerize-proxy="1"]')) {
        var hostD = getMirrorHost(rightCol, 'desktop');
        if (hostD) hostD.appendChild(buildMirror(source, section, 'desktop'));
      }
      source.setAttribute('data-lmx-measmerize-wired', '1');
      return true;
    }

    if (inRight && mobileCol) {
      if (!mobileCol.querySelector('[data-lmx-measmerize-proxy="1"]')) {
        var hostM = getMirrorHost(mobileCol, 'mobile');
        if (hostM) hostM.appendChild(buildMirror(source, section, 'mobile'));
      }
      source.setAttribute('data-lmx-measmerize-wired', '1');
      return true;
    }

    return false;
  }

  function canPlaceMirror(source) {
    if (!source || !source.querySelector('button')) return null;
    var section = getPdpSection(source);
    if (!section) return null;
    var inMobile = source.closest('.lmx-mobile-content');
    var inRight = source.closest('.lmx-col-right');
    var mobileCol = section.querySelector('.lmx-mobile-content');
    var rightCol = section.querySelector('.lmx-col-right');
    if ((inMobile && rightCol) || (inRight && mobileCol)) return true;
    return false;
  }

  function tryLoop() {
    var n = 0;
    var tick = function () {
      if (placeProxies()) return;
      var source = document.getElementById('measmerize-button');
      var possible = canPlaceMirror(source);
      if (source && source.querySelector('button') && possible === false) return;
      n += 1;
      if (n < RETRY_MAX) setTimeout(tick, RETRY_MS);
    };
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryLoop);
  } else {
    tryLoop();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e && e.target;
    var sec =
      root && root.querySelector && root.querySelector('[data-lmx-pdp="1"]');
    if (!sec && root && root.getAttribute && root.getAttribute('data-lmx-pdp') === '1') sec = root;
    if (sec) removeProxies(sec);
    setTimeout(tryLoop, 0);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e && e.target;
    var sec =
      root && root.querySelector && root.querySelector('[data-lmx-pdp="1"]');
    if (!sec && root && root.getAttribute && root.getAttribute('data-lmx-pdp') === '1') sec = root;
    if (sec) removeProxies(sec);
  });
})();

// ==========================================================================
// PRODUCT BACK-IN-STOCK MODAL
// Apre .product-back-modal quando l'utente seleziona una taglia non disponibile
// ==========================================================================

(function () {
  function openBackModal(modal, sizeValue) {
    var sizeEl = modal.querySelector('.product-back-modal__size-value');
    if (sizeEl) sizeEl.textContent = sizeValue;

    var form = modal.querySelector('.product-back-modal__form');
    var success = modal.querySelector('.product-back-modal__success');
    var emailInput = modal.querySelector('.product-back-modal__input');
    if (form) form.classList.remove('hidden');
    if (success) success.classList.add('hidden');
    if (emailInput) emailInput.value = '';

    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (emailInput) {
      setTimeout(function () { emailInput.focus(); }, 350);
    }
  }

  function closeBackModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function initBackModal(modal) {
    var overlay = modal.querySelector('.product-back-modal__overlay');
    var closeBtn = modal.querySelector('.product-back-modal__close');
    var form = modal.querySelector('.product-back-modal__form');
    var success = modal.querySelector('.product-back-modal__success');

    if (overlay) {
      overlay.addEventListener('click', function () { closeBackModal(modal); });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeBackModal(modal); });
    }

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && modal.classList.contains('is-open')) {
        closeBackModal(modal);
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        form.classList.add('hidden');
        if (success) success.classList.remove('hidden');
      });
    }
  }

  function bindVariantPickerClicks() {
    document.querySelectorAll('.lmx-variant-picker').forEach(function (picker) {
      if (picker.dataset.backModalBound) return;
      picker.dataset.backModalBound = '1';

      picker.addEventListener('click', function (e) {
        var label = e.target.closest('label.product__item-option, label.product__color-swatches--js');
        if (!label) return;

        var inputId = label.getAttribute('for');
        if (!inputId) return;

        var input = document.getElementById(inputId);
        if (!input || !input.classList.contains('option-disabled')) return;

        var sizeValue =
          (label.querySelector('.swatche-item') || label.querySelector('span:not(.tooltip-content)') || label)
            .textContent.trim();

        // Preferisce la modale che contiene il form iniettato dall'app (solo uno dei due dialog viene popolato)
        var rrInline = document.getElementById('restock-rocket-inline-container');
        var modal =
          (rrInline && rrInline.closest('.product-back-modal')) ||
          (picker.parentElement && picker.parentElement.querySelector('.product-back-modal')) ||
          document.querySelector('.product-back-modal');

        if (modal) openBackModal(modal, sizeValue);
      });
    });
  }

  // Sposta le modali su document.body in modo che non siano mai figlie di un
  // container con display:none (es. .lmx-mobile-content su desktop).
  // position:fixed le rende indipendenti dal flusso, quindi lo spostamento è sicuro.
  function hoistModals() {
    document.querySelectorAll('.product-back-modal').forEach(function (modal) {
      if (modal.parentElement && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function init() {
    hoistModals();
    document.querySelectorAll('.product-back-modal').forEach(initBackModal);
    bindVariantPickerClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    hoistModals();
    document.querySelectorAll('.product-back-modal').forEach(initBackModal);
    bindVariantPickerClicks();
  });
})();

// ==========================================================================
// IUBENDA BADGE — nasconde solo il badge floating, non i link in footer
// ==========================================================================

(function () {
  function hideIubendaBadge() {
    document.querySelectorAll('.iubenda-tp-btn.iubenda-cs-preferences-link').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  hideIubendaBadge();

  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(hideIubendaBadge);
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
